/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectTimeUpdateCommand } from '../../models/create-project-time-update-command';
import { CreateProjectTimeUpdateCommandResult } from '../../models/create-project-time-update-command-result';

export interface ApiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain$Params {
      body?: CreateProjectTimeUpdateCommand
}

export function apiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTimeUpdateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectTimeUpdateCommandResult>;
    })
  );
}

apiProjectTimeUpdateCreateProjectTimeUpdatePost$Plain.PATH = '/api/ProjectTimeUpdate/CreateProjectTimeUpdate';
